import { createContext, useContext, useEffect, useRef, useState } from "react";
import { effectivePrice } from "@/lib/format";
import api from "@/lib/api";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tb_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("tb_cart", JSON.stringify(items));
  }, [items]);

  const firstSync = useRef(true);
  useEffect(() => {
    if (firstSync.current) { firstSync.current = false; return; }
    if (!localStorage.getItem("tb_token")) return;
    const t = setTimeout(() => {
      api.post("/cart", { items: items.map((i) => ({ product_id: i.product_id, name: i.name, price: i.price, quantity: i.quantity, unit: i.unit || "unité", image: i.image || "" })) }).catch(() => {});
    }, 1500);
    return () => clearTimeout(t);
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: effectivePrice(product),
        quantity: qty, unit: product.unit, image: (product.images || [])[0] || "",
      }];
    });
  };

  const setQty = (pid, qty) => {
    setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  };

  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
